import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'antd';

import Styles from './HamburgerMenu.module.scss';
import HamburgerMenuImage from 'images/hamburger-menu-black.png';
import Image from 'Pages/Home/Components/Atoms/Image';

const HamburgerMenu: React.FC = () => {
  return (
    <Col>
      <Image
        src={HamburgerMenuImage}
        className={Styles['hamburger-menu-image']}
      />
    </Col>
  );
};

export default HamburgerMenu;
